import { Box } from "@mui/material"
import { PayoffLeg } from "../../payoffContainer/livePayoffContainer"
import { memo, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react"
import PayoffOrderTag from "./payoffOrderTag"
import { PayoffGraphContext } from "../payoffGraphContext"
import { useSelector } from "react-redux"
import { selectIsEmbedded } from "../../../selectors/device"

export type PayoffGraphOrderTagsProps = {
    payoffLegs: PayoffLeg[],
    readonly?: boolean
}

export type OrderSlidersHandle = {
    getSliderElements: () => OrderSlidersElements
}

export type OrderSlidersElements = Record<string, HTMLDivElement>

const PayoffGraphOrderTags: React.FC<PayoffGraphOrderTagsProps>= ({payoffLegs, readonly}) => {
    const isEmbedded = useSelector(selectIsEmbedded)
    const payoffGraphContext = useContext(PayoffGraphContext);
    const orderSlidersElementsRef = useRef<OrderSlidersElements>({})
    const [elementsVersion, setElementsVersion] = useState(0)
    const style = useMemo(() => ({
        height: '100%',
        width: '100%',
        position: 'relative',
    }), [payoffLegs])

    const setHtmlElement = useCallback((legId: string) => (ele: HTMLDivElement | null) => {
        if (ele) {
            orderSlidersElementsRef.current[legId] = ele
        } else {
            delete orderSlidersElementsRef.current[legId]
        }
        queueMicrotask(() => setElementsVersion(v => v + 1))
    }, [])

    // useEffect(() => {
        // Don't reset to empty object immediately, let the cleanup happen naturally
        // orderSlidersElementsRef.current = {}
    // }, [payoffLegs])

    const tags = useMemo(() => {
        return payoffLegs.map((leg) => (
            <PayoffOrderTag
                key={leg.id}
                payoffLeg={leg}
                setHtmlElement={setHtmlElement(leg.id)}
                readonly={readonly}
            />
        ))
    }, [payoffLegs, readonly, setHtmlElement])

    useEffect(() => {
        payoffGraphContext.updateSliderElements({ ...orderSlidersElementsRef.current })
    }, [payoffLegs, payoffGraphContext, elementsVersion])

    return  <Box sx={style}>
                {isEmbedded ? null : tags}
            </Box>
}

export default memo(PayoffGraphOrderTags);